import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { CommonService } from 'src/app/Service/Common.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthGuard implements CanActivate {
    CLientPages: string[] = ['clientdashboard', 'waybill'];
    DriverPages: string[] = ['clientdashboard', 'waybill'];
    constructor(
        private router: Router,
        private commServ: CommonService,
        private permissionsService: NgxPermissionsService
    ) {
    }

    canActivate() {
        if (localStorage.getItem('worqforctoken')) {
            const Page = localStorage.getItem('Page');
            if (Page === '/addcompany' || Page === '/addtechnician') {
                this.router.navigate([Page]);
                return false;
            }
            return true;
        }
        this.router.navigate(['/login']);
        return false;
    }
}
